<div class="w-screen">
      <router-outlet></router-outlet>
      <iho-notification></iho-notification>
</div>

<div *ngIf="showPWA" class="fixed bottom-20 right-5  z-50 bg-white border border-gray-300 shadow-lg rounded-lg px-4 py-3 flex items-center justify-center">
      <div class="text-sm">
            <span (click)="dismissInstallPrompt()" class="ico-Close text-sm bg-blue-400 text-white rounded-full px-1 absolute top-[-10px] right-[-10px]"></span>
            اپلیکیشن به صفحه اصلی خود اضافه کنید
      </div>
      <button (click)="installApp()"
      class="w-full h-[40px]  bg-blue-500 rounded-lg text-md text-white md:text-xl hover:bg-blue-600 duration-100 transition-all mr-2">
                  نصب        
      </button>
</div>
<div *ngIf="showInstallGuide"
      class="fixed bottom-20 left-5 right-5 bg-white shadow-md p-4 rounded-lg text-sm text-gray-800 z-50">
      برای نصب اپ، در Safari روی
      <span class="font-bold">Share</span> (آیکون ⬆️) بزنید و گزینه
      <span class="font-bold">Add to Home Screen</span> را انتخاب کنید.
      <span (click)="showInstallGuide = false"
      class="ico-Close text-sm bg-blue-400 text-white rounded-full px-1 absolute top-[-10px] right-[-10px]"></span>
</div>
    